import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
  DeskTopCalVW,
  MaxCalVW,
  MobileCalVW,
  TabletCalVW,
} from '../utils/CalVW';
import { media } from './Qtheme';
import { DatePicker } from 'antd';
import { Dayjs } from 'dayjs';

const PRIMARY_COLOR = '#007AFF';

export const GlobalContainer = styled.div`
  @media ${media.desktop} {
    padding-top: 56.23px;
  }
`;
export const CommonContainer = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 71px;
  margin-top: 80px;
`;

export const ListTitle = styled.h4`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.text};
  font-family: 'Pretendard', sans-serif;
  display: flex;
  align-items: center;

  & svg {
    margin-right: 6px;
  }

  // @media ${media.desktop2} {
  //     font-size: ${DeskTopCalVW(22)};
  // }
  //
  // @media ${media.desktop} {
  //     font-size: ${TabletCalVW(22)};
  // }

  @media ${media.mobile} {
    font-size: ${MobileCalVW(16)};
  }
`;

export const TitleContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'themeState',
})<{ themeState?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  font-family: Arial, sans-serif;
  border-bottom: ${({ themeState }) =>
    themeState === 'dark' ? '0' : '1px solid #E8E8E8'};

  border-top-left-radius: 16px;
  border-top-right-radius: 16px;

  @media ${media.mobile} {
    padding: 0 ${MobileCalVW(14)};
    height: ${MobileCalVW(54)};
  }
`;

export const MoreLink = styled(Link)`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.moreText};

  &:hover {
    color: #cccccc;
  }

  span {
    // @media ${media.max} {
    //     font-size: ${MaxCalVW(22)};
    //     line-height: ${MaxCalVW(25.3)};
    // }
    //
    // @media ${media.desktop} {
    //     font-size: ${TabletCalVW(22)};
    //     line-height: ${TabletCalVW(25.3)};
    // }

    @media ${media.mobile} {
      font-size: ${MobileCalVW(12)};
      line-height: ${MobileCalVW(15.51)};
    }
  }
`;

export const ListColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AuthWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-top: 122px;
  padding-bottom: 190px;

  @media ${media.desktop2} {
    width: ${DeskTopCalVW(1920)};
  }
`;

export const AuthBox = styled.div`
  position: relative;
  width: 460px;
  border: 1px solid ${({ theme }) => theme.COLORS.PrimaryTableBorder};
  min-height: 522px;
  border-radius: 12px;
  font-family: 'Pretendard', sans-serif;
  background-color: ${({ theme }) => theme.COLORS.PrimaryTableBg};
  padding: 50px 32px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media ${media.mobile} {
    width: 100%;
    margin: 0 ${MobileCalVW(16)};
  }
`;

export const Form = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isUid',
})<{ isUid?: boolean }>`
  display: flex;
  flex-direction: column;

  & * {
    transition: all 0.5s ease;
  }

  label {
    font-size: 20px;
    font-weight: 400;
    color: ${({ theme }) => theme.text};
    transition: all 0.5s ease-in-out;
  }

  .react-tel-input {
    margin-bottom: 10px;
  }

  input {
    width: 100%;
    height: 54px;
    padding: 0 24px;
    border: none;
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.inputPlaceholderText};
    box-sizing: border-box;
    outline: none;
    background-color: ${({ theme }) => theme.COLORS.PrimaryInputBg};
    border: ${({ theme }) => theme.COLORS.PrimaryInputBorder} 1px solid;
    border-radius: 8px;
    margin-bottom: 10px;
  }
`;

export const NextBtn = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'buttonType',
})<{ buttonType?: string }>`
  background: ${({ buttonType }) =>
    buttonType === 'signup' ? 'transparent' : PRIMARY_COLOR};
  width: 100%;
  height: 43px;
  border: ${({ buttonType }) =>
    buttonType === 'signup' ? '1px solid #007AFF' : 'none'}; /* 테두리 제거 */
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme, buttonType }) =>
    buttonType === 'signup' ? PRIMARY_COLOR : '#FFFFFF'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease;
  margin-bottom: 8px;

  &:hover {
    background: ${({ buttonType }) =>
      buttonType === 'signup'
        ? 'transparent'
        : 'linear-gradient( 0deg, # rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.3) 100%),  linear-gradient(90deg, #38c4f6 0%, #e10ff0 100%)'};
  }
`;

export const ContinueBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 18px;
  margin: 50px 0;

  div {
    width: 222px;
    height: 2px;
    background-color: #37c4f6;

    @media ${media.mobile} {
      width: 100%;
    }
  }

  p {
    font-size: 20px;
    font-weight: 400;
    color: #37c4f6;
  }
`;

export const SocialBtnBox = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
`;

export const SocialBtn = styled.button`
  width: 100%;
  height: 52px;
  border: ${({ theme }) => `1px solid ${theme.COLORS.ButtonBorder}`};
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const StyledDatePicker = styled(DatePicker<Dayjs>)`
  &.ant-picker {
    border: 1px solid
      ${({ theme }) => theme.COLORS.ButtonBorder || 'rgba(255, 255, 255, 0.2)'} !important;
    transition: all 0.3s ease !important;
    cursor: pointer !important;

    &:hover {
      border-color: ${({ theme }) =>
        theme.COLORS.primary || '#007AFF'} !important;
      box-shadow: 0 2px 8px rgba(0, 122, 255, 0.2) !important;
    }

    &.ant-picker-focused {
      border-color: ${({ theme }) =>
        theme.COLORS.primary || '#007AFF'} !important;
      box-shadow: 0 0 0 2px rgba(0, 122, 255, 0.2) !important;
    }
  }
`;
